import axios from 'axios';
const baseUrl = process.env.REACT_APP_BASEURL;

export async function getAppInsightsConnStr() {
  try {
    const response = await axios.get(baseUrl + `api/Config/AppInsights`);

    if (!(response.status === 200)) {
      throw new Error(
        `Failed to fetch App Insights config: ${response.statusText}`
      );
    }

    const config = response.data;
    return config.connectionString;
  } catch (ex) {
    return { data: null, msg: ex.message };
  }
}